export const FILTER_OPEN_CLASS = "filter-open";
export const FILTER_SEARCH_OPEN_CLASS = "filter-search-open";
